import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CustomerState } from "../models/customer-state.model";
import { CustomerContactDataDetails } from "../models/customer.model";
import { StateService } from "../../../../state/state.service";

const initialState: CustomerState = null;

@Injectable({
  providedIn: "root",
})
export class CustomerStateService extends StateService<CustomerState> {
  constructor() {
    super(initialState);
  }

  getCustomerContactDetails$(): Observable<CustomerContactDataDetails> {
    return this.select((state: CustomerState) => state?.customerContactDetails);
  }

  setCustomerContactDetails(
    customerContactDetails: CustomerContactDataDetails
  ): void {
    const newState = {
      ...this.state,
      customerContactDetails,
    };
    this.setState(newState);
  }

  isCustomerContactDetailsStateLoaded(): boolean {
    return !!this.state?.customerContactDetails;
  }

  clearState(): void {
    this.initState(initialState);
  }
}
